import { HANDLE_CONFIGURATION, RESET } from '../actions';

const initialState = {
    configAPICalled: false,
    powerMeter: {},
    powerMeterDevice: {},
    powerMeterReport: [],
    powerMeterLive: [],
    powerMeterStatus: {
        offline: "",
        idle: "",
        running: "",
        offlineHour: "",
        idleStart: "",
        idleEnd: ""
    },
    powerMeterReportConfig: {},
    nameConfig: {},
    autoRefresh: {}
};

const BitDetails = (state = initialState, action) => {
    
    switch (action.type) {
        case HANDLE_CONFIGURATION:
            return {
                ...state,
                ...action.data
            };
        case RESET:
            return initialState;
        default:
            return state;
    }
};

export default BitDetails;